<!--The content below is only a placeholder and can be replaced.-->
<div class="wrapper" [ngClass]="getClasses()">
	<!-- La navbar en haut de la page (permanente, sur toute les pages sauf /login )-->
	<app-topbar *ngIf="!isHomeContent && !isMobile"></app-topbar>

	<app-mobile-navbar *ngIf="!isHomeContent && isMobile"></app-mobile-navbar>

	<main>
		<!-- La side bar (gauche) activable -->
		<app-sidebar
			*ngIf="!isHomeContent && !isMobile"
			[isSidebardHidden]="isSidebardHidden"
			(toggleSidebarPinEmitter)="toggleSidebarPin()"
		></app-sidebar>

		<div class="pages" [ngClass]="getPagesClasses()">
			<!-- Là où va être générer les pages de l'appli -->
			<div>
				<router-outlet></router-outlet>
			</div>
			<!-- Footer Isycare Technology -->
			<app-footer *ngIf="!isHomeContent && !isMobile"></app-footer>
		</div>
	</main>
</div>
